import * as React from 'react';
import * as Redux from 'redux';

export interface IBaseButtonProps {
    onClick?: () => void;
    customClasses?: string;
    buttonText?: string;
    isDisabled?: boolean;
    id?: string
    testID?: string
}

/// <summary>
/// This class can be used for an AAP button
/// </summary>
/// <param name="isDisabled">Determines whether or not to show the disabled state</param>
/// <param name="buttonText">Default button text</param>
/// <param name="onClick">Callback for the buttons onClick event</param>
/// <param name="customClasses">Used to supply any additional classes to the button</param>
/// <returns></returns>
export class BaseButton extends React.Component<IBaseButtonProps, any> {
    static defaultProps = {
        onClick: () => { },
        customClasses: '',
        buttonText: '',
        isDisabled: false,
        testID: '',
    }

    GetClassNames() {
        let DISABLED_STYLE = " disabled";
        let classes = this.props.customClasses;
        if (this.props.isDisabled)
            classes += DISABLED_STYLE;
        return classes;
    }

    onButtonClick() {
        if (!this.props.isDisabled)
            this.props.onClick();
    }

    render() {
        let boundClick = this.onButtonClick.bind(this);
        return (
            <div className="button-wrapper">
                <a
                    className={this.GetClassNames()}
                    id={this.props.id ? `${this.props.id}-save` : ""}
                    onClick={boundClick}
                    data-testid={this.props.testID}
                >
                    {this.props.buttonText}
                </a>
            </div>
        );
    }
}